import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { UserSearchResponse } from '../models/user-search-response.model';
import { UserSearchParams } from '../models/user-search-params.model';
import { ModifyUserParams } from '../models/modify-user-params.model';
import { User } from '../models/user.model';
import { CompanyRole } from '../models/company-role.model';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private apiService: ApiService) { }

  /**
   * Search for users that this auth'd user can view
   * @param params The object that holds details about the search
   */
  public searchForUsers(params: UserSearchParams): Promise<UserSearchResponse> {
    return this.apiService.post(`/users/search`, params);
  }

  /**
   * Retrieve users that this auth'd user can view
   * @param params The object that holds details about the search
   */
  public getUserById(uuid: string): Promise<User> {
    return this.apiService.get(`/users/${uuid}`);
  }

  /**
   * Bulk modify users information
   * @param action Controls what endpoint we send the bulk users to
   * @param params Array of objects that holds details about the bulk edited users
   */
  public modifyUser(action: string, params: ModifyUserParams[]): Promise<any> {
    console.log("Got to modify user in user service");

    if(action === "Edit") {
      return this.apiService.put(`/users/bulk`, params);
    } else if(action === "Delete") {
      return this.apiService.post(`/users/bulk`, params);
    }
  }

  /**
   * Create a brand new user
   * @param userInfo The object that holds details about the new user
   */
  public createUser(userInfo: User): Promise<User> {
    console.log("Got to create user in the user service", userInfo);
    return this.apiService.post(`/users`, userInfo);
  }

  /**
   * Update an existing user
   * @param userInfo The object that holds details about the updated user
   */
  public updateUser(userInfo: User): Promise<User> {
    console.log("Got to update user in the user service", userInfo);
    return this.apiService.put(`/users/${userInfo.userId}`, userInfo);
  }

  /**
   * Get all of the roles in the database
   */
  public getRolesAndCompanies(): Promise<CompanyRole[]> {
    console.log("Got to get roles/companies in the user service");
    return this.apiService.get(`/users/roles`);
  }

  /**
   * Trigger a password reset email to be sent to the user
   */
  public passwordReset(uuid: String): Promise<any> {
    console.log("Got to get password reset in the user service");
    return this.apiService.post(`/users/${uuid}/passwordreset`, {});
  }

  public lockUser(uuid: String): Promise<any> {
    return this.apiService.post(`/users/lock/${uuid}`, {});
  }

  public unlockUser(uuid: String): Promise<any> {
    return this.apiService.post(`/users/unlock/${uuid}`, {});
  }

}
